// stocai_frontend/src/components/HomePage/components/widgets/Module7/Steps/WhoYouBecameStep.jsx

import React, { useState, useRef, useEffect } from "react";
import bgFutureImg from "../../../../../../assets/bg_future.png";
import futurePersonImg from "../../../../../../assets/future_person_2.png";

const WhoYouBecameStep = ({
  userId,
  subsectionId,
  beliefs,
  setBeliefs,
  behaviours,
  setBehaviours,
  risks,
  setRisks,
  onNextStep,
}) => {
  const [rightSubmitted, setRightSubmitted] = useState(false);
  const [leftVisible, setLeftVisible] = useState(false);
  const [leftSubmitted, setLeftSubmitted] = useState(false);
  const [riskVisible, setRiskVisible] = useState(false);
  const [riskSubmitted, setRiskSubmitted] = useState(false);

  // Refs for scroll containers
  const beliefsScrollRef = useRef(null);
  const behavioursScrollRef = useRef(null);
  const risksScrollRef = useRef(null);

  // Auto-scroll and focus when new items are added
  useEffect(() => {
    if (beliefsScrollRef.current && beliefs.length > 2) {
      beliefsScrollRef.current.scrollTop = beliefsScrollRef.current.scrollHeight;
      // Focus the last input
      const inputs = beliefsScrollRef.current.querySelectorAll('input');
      if (inputs.length > 0) inputs[inputs.length - 1].focus();
    }
  }, [beliefs.length]);

  useEffect(() => {
    if (behavioursScrollRef.current && behaviours.length > 2) {
      behavioursScrollRef.current.scrollTop = behavioursScrollRef.current.scrollHeight;
      const inputs = behavioursScrollRef.current.querySelectorAll('input');
      if (inputs.length > 0) inputs[inputs.length - 1].focus();
    }
  }, [behaviours.length]);

  useEffect(() => {
    if (risksScrollRef.current && risks.length > 2) {
      risksScrollRef.current.scrollTop = risksScrollRef.current.scrollHeight;
      const inputs = risksScrollRef.current.querySelectorAll('input');
      if (inputs.length > 0) inputs[inputs.length - 1].focus();
    }
  }, [risks.length]);

  const addBelief = () => {
    setBeliefs((prev) => [...prev, { id: prev.length + 1, text: "" }]);
  };
  const addBehaviour = () => {
    setBehaviours((prev) => [...prev, { id: prev.length + 1, text: "" }]);
  };
  const addRisk = () => {
    setRisks((prev) => [...prev, { id: prev.length + 1, text: "" }]);
  };

  const updateBelief = (index, value) => {
    setBeliefs((prev) => {
      const copy = [...prev];
      copy[index] = { ...(copy[index] || {}), text: value };
      return copy;
    });
  };
  const updateBehaviour = (index, value) => {
    setBehaviours((prev) => {
      const copy = [...prev];
      copy[index] = { ...(copy[index] || {}), text: value };
      return copy;
    });
  };
  const updateRisk = (index, value) => {
    setRisks((prev) => {
      const copy = [...prev];
      copy[index] = { ...(copy[index] || {}), text: value };
      return copy;
    });
  };

  // Remove functions for deleting extra inputs
  const removeBelief = (index) => {
    setBeliefs((prev) => prev.filter((_, i) => i !== index));
  };
  const removeBehaviour = (index) => {
    setBehaviours((prev) => prev.filter((_, i) => i !== index));
  };
  const removeRisk = (index) => {
    setRisks((prev) => prev.filter((_, i) => i !== index));
  };

  const handleRightContinue = () => {
    setRightSubmitted(true);
    setLeftVisible(true);
  };

  const handleLeftContinue = () => {
    setLeftSubmitted(true);
    setRiskVisible(true);
  };

  const handleRiskReveal = () => {
    setRiskSubmitted(true);
    if (onNextStep) {
      onNextStep({
        beliefs: beliefs.map((b) => b.text || ""),
        behaviours: behaviours.map((b) => b.text || ""),
        risks: risks.map((r) => r.text || ""),
      });
    }
  };

  return (
    <div className="w-full h-full bg-white flex flex-col items-center">
      <div className="mb-2 flex flex-col items-center text-center px-4">
        <h1 className="text-[28px] md:text-[32px] font-[500] leading-[135%] text-[#000000] mb-2 font-[Gotham]">
          Who you became?
        </h1>

        <p className="text-[19px] font-[400] leading-[165%] text-[#323232] max-w-[620px] font-[Gotham]">
          What did you do differently? Map the identity shift that made promotion inevitable.
        </p>
      </div>

      <div className="w-full flex justify-center mb-10">
        <div className="relative w-[760px] h-[520px]">
          <img
            src={bgFutureImg}
            alt="Boardroom background"
            className="absolute inset-0 m-auto w-[758px] h-[874px] object-contain pointer-events-none select-none"
            draggable={false}
          />

          <div className="absolute w-[285.8428px] h-[285.8428px] top-[10px] left-[225px] rounded-full bg-[#54B0AF] opacity-100" />

          <img
            src={futurePersonImg}
            alt="Future you"
            className="absolute w-[510px] h-[750px] bottom-[-240px] left-[120px] object-contain pointer-events-none select-none z-10"
            draggable={false}
          />

          {/* RIGHT connector (initial) */}
          <div
            className="absolute z-30 pointer-events-none"
            style={{
              top: "195px",
              left: "400px",
              width: "178px",
              height: "0px",
            }}
          >
            <div className="relative w-full h-0">
              <div className="absolute left-0 top-0 w-full border-t-4 border-black" />
              <div
                className="absolute rounded-full bg-black"
                style={{
                  width: "16px",
                  height: "16px",
                  top: "-6px",
                  right: "-8px",
                }}
              />
            </div>
          </div>

          {/* LEFT connector (appears when leftVisible) */}
          <div
            className="absolute z-25 pointer-events-none"
            style={{
              top: "300px",
              left: "140px",
              width: "178.44921875px",
              height: "0px",
              opacity: leftVisible ? 1 : 0,
            }}
          >
            <div className="relative w-full h-0">
              <div className="absolute left-0 top-0 w-full border-t-4 border-black" />
              <div
                className="absolute rounded-full bg-black"
                style={{
                  width: "16px",
                  height: "16px",
                  top: "-6px",
                  left: "-8px",
                }}
              />
            </div>
          </div>

          {/* RISK connector (bottom-right) */}
          <div
            className="absolute z-28 pointer-events-none"
            style={{
              top: "440px",
              left: "400px",
              width: "178px",
              height: "0px",
              opacity: riskVisible ? 1 : 0,
            }}
          >
            <div className="relative w-full h-0">
              <div className="absolute left-0 top-0 w-full border-t-4 border-black" />
              <div
                className="absolute rounded-full bg-black"
                style={{
                  width: "16px",
                  height: "16px",
                  top: "-6px",
                  right: "-8px",
                }}
              />
            </div>
          </div>

          {/* RIGHT block: Beliefs changed */}
          <div className="absolute z-20 top-[180px] left-[600px] w-[392px]">
            <p className="font-[Gotham] font-[700] text-[16px] leading-[165%] uppercase" style={{ color: "#54B0AF" }}>
              BELIEFS CHANGED
            </p>

            <div className="flex flex-col">
              {/* Scrollable container for inputs - max height for 2 items */}
              <div ref={beliefsScrollRef} className="max-h-[104px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300">
                {rightSubmitted
                  ? beliefs.map((b) => (
                      <div key={b.id} className="w-[340.166px] h-[51.879px] bg-white flex items-center gap-3">
                        <span className="text-[#323232] text-[18px] leading-[100%]">•</span>
                        <div
                          className="flex-1 h-full text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232] flex items-center"
                          style={{ borderBottom: "1px solid rgba(0,0,0,0.12)", paddingTop: "12px", paddingBottom: "12px" }}
                        >
                          <span className={b.text && b.text.trim() !== "" ? "" : "text-[#B8B8B8]"}>
                            {b.text && b.text.trim() !== "" ? b.text : `New Belief ${b.id}`}
                          </span>
                        </div>
                      </div>
                    ))
                  : beliefs.map((b, i) => (
                      <div key={b.id} className="w-[340.166px] h-[51.879px] bg-white flex items-center gap-3">
                        <span className={b.text && b.text.trim() !== "" ? "text-[#323232] text-[18px]" : "text-[#B8B8B8] text-[18px]"} aria-hidden>
                          •
                        </span>

                        <input
                          value={b.text}
                          onChange={(e) => updateBelief(i, e.target.value)}
                          placeholder={`New Belief ${b.id}`}
                          className="flex-1 h-full outline-none bg-transparent placeholder:text-[#B8B8B8] text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232]"
                          style={{
                            border: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.12)",
                            paddingLeft: 0,
                            paddingTop: "12px",
                            paddingBottom: "12px",
                          }}
                        />

                        {/* Delete button for extra inputs (beyond initial 2) */}
                        {i >= 2 && (
                          <button
                            type="button"
                            onClick={() => removeBelief(i)}
                            className="ml-1 text-gray-400 hover:text-gray-700 transition-colors cursor-pointer"
                            style={{ background: "transparent", border: "none", padding: "4px" }}
                            title="Remove"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}
              </div>

              {!rightSubmitted && (
                <>
                  <div className="w-[340.166px]">
                    <button type="button" onClick={addBelief} className="mt-1 flex items-center gap-3" style={{ background: "transparent", padding: 0, border: "none" }}>
                      <span className="text-[18px] font-[400] font-[Gotham] text-[#B8B8B8]">+ Add more</span>
                    </button>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      onClick={handleRightContinue}
                      className="flex items-center justify-between w-[255px] h-[56px] rounded-[16.2px] bg-[#0D1111] text-white text-[17.01px] font-[350] font-[Gotham] leading-[100%] px-[16.2px] py-[17.82px]"
                    >
                      <span>Go to Next</span>
                      <span className="ml-3 flex items-center justify-center w-[18px] h-[18px] rounded-full bg-white text-black">
                        <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
                          <path d="M8 5l4 5-4 5" stroke="#151A1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* LEFT block: New behaviours adopted */}
          <div className="absolute z-20" style={{ top: "290px", left: "-220px", width: "392px", opacity: leftVisible ? 1 : 0 }}>
            <p className="font-[Gotham] font-[700] text-[16px] leading-[165%] uppercase" style={{ color: "#54B0AF" }}>
              NEW BEHAVIOURS ADOPTED
            </p>

            <div className="flex flex-col">
              {/* Scrollable container for inputs - max height for 2 items */}
              <div ref={behavioursScrollRef} className="max-h-[104px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300">
                {leftSubmitted
                  ? behaviours.map((b) => (
                      <div key={b.id} className="w-[340.166px] h-[51.879px] flex items-center gap-3 bg-transparent">
                        <span className="text-[#323232] text-[18px] leading-[100%]">•</span>
                        <div
                          className="flex-1 h-full text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232] flex items-center"
                          style={{ borderBottom: "1px solid rgba(0,0,0,0.12)", paddingTop: "12px", paddingBottom: "12px" }}
                        >
                          <span className={b.text && b.text.trim() !== "" ? "" : "text-[#B8B8B8]"}>{b.text && b.text.trim() !== "" ? b.text : `Behaviour ${b.id}`}</span>
                        </div>
                      </div>
                    ))
                  : behaviours.map((b, i) => (
                      <div key={b.id} className="w-[340.166px] h-[51.879px] bg-transparent flex items-center gap-3">
                        <span className={b.text && b.text.trim() !== "" ? "text-[#323232] text-[18px]" : "text-[#B8B8B8] text-[18px]"} aria-hidden>
                          •
                        </span>

                        <input
                          value={b.text}
                          onChange={(e) => updateBehaviour(i, e.target.value)}
                          placeholder={`Behaviour ${b.id}`}
                          className="flex-1 h-full outline-none bg-transparent placeholder:text-[#B8B8B8] text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232]"
                          style={{
                            border: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.12)",
                            paddingLeft: 0,
                            paddingTop: "12px",
                            paddingBottom: "12px",
                          }}
                        />

                        {/* Delete button for extra inputs (beyond initial 2) */}
                        {i >= 2 && (
                          <button
                            type="button"
                            onClick={() => removeBehaviour(i)}
                            className="ml-1 text-gray-400 hover:text-gray-700 transition-colors cursor-pointer"
                            style={{ background: "transparent", border: "none", padding: "4px" }}
                            title="Remove"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}
              </div>

              {!leftSubmitted && leftVisible && (
                <>
                  <div className="w-[340.166px]">
                    <button type="button" onClick={addBehaviour} className="mt-1 flex items-center gap-3" style={{ background: "transparent", padding: 0, border: "none" }}>
                      <span className="text-[18px] font-[400] font-[Gotham] font-medium text-[#B8B8B8]">+ Add more</span>
                    </button>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      onClick={handleLeftContinue}
                      className="flex items-center justify-between w-[255px] h-[56px] rounded-[16.2px] bg-[#0D1111] text-white text-[17.01px] font-[350] font-[Gotham] leading-[100%] px-[16.2px] py-[17.82px]"
                    >
                      <span className="font-medium font-gotham">Go to Next</span>
                      <span className="ml-3 flex items-center justify-center w-[18px] h-[18px] rounded-full bg-white text-black">
                        <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
                          <path d="M8 5l4 5-4 5" stroke="#151A1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          {/* RIGHT-BOTTOM block: Risks Taken */}
          <div className="absolute z-20" style={{ top: "435px", left: "600px", width: "392px", opacity: riskVisible ? 1 : 0 }}>
            <p className="font-[Gotham] font-[700] text-[16px] leading-[165%] uppercase" style={{ color: "#54B0AF" }}>
              RISKS TAKEN
            </p>

            <div className="flex flex-col">
              {/* Scrollable container for inputs - max height for 2 items */}
              <div ref={risksScrollRef} className="max-h-[104px] overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300">
                {riskSubmitted
                  ? risks.map((r) => (
                      <div key={r.id} className="w-[340.166px] h-[51.879px] bg-transparent flex items-center gap-3">
                        <span className="text-[#323232] text-[18px] leading-[100%]">•</span>
                        <div
                          className="flex-1 h-full text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232] flex items-center"
                          style={{ borderBottom: "1px solid rgba(0,0,0,0.12)", paddingTop: "12px", paddingBottom: "12px" }}
                        >
                          <span className={r.text && r.text.trim() !== "" ? "" : "text-[#B8B8B8]"}>{r.text && r.text.trim() !== "" ? r.text : r.placeholder}</span>
                        </div>
                      </div>
                    ))
                  : risks.map((r, i) => (
                      <div key={r.id} className="w-[340.166px] h-[51.879px] bg-white flex items-center gap-3">
                        <span className={r.text && r.text.trim() !== "" ? "text-[#323232] text-[18px]" : "text-[#B8B8B8] text-[18px]"} aria-hidden>
                          •
                        </span>

                        <input
                          value={r.text}
                          onChange={(e) => updateRisk(i, e.target.value)}
                          placeholder={`Risk Taken ${r.id}`}
                          className="flex-1 h-full outline-none bg-transparent placeholder:text-[#B8B8B8] text-[18px] leading-[100%] font-[Gotham] font-[325] text-[#323232]"
                          style={{
                            border: "none",
                            borderBottom: "1px solid rgba(0,0,0,0.12)",
                            paddingLeft: 0,
                            paddingTop: "12px",
                            paddingBottom: "12px",
                          }}
                        />

                        {/* Delete button for extra inputs (beyond initial 2) */}
                        {i >= 2 && (
                          <button
                            type="button"
                            onClick={() => removeRisk(i)}
                            className="ml-1 text-gray-400 hover:text-gray-700 transition-colors cursor-pointer"
                            style={{ background: "transparent", border: "none", padding: "4px" }}
                            title="Remove"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>
                        )}
                      </div>
                    ))}
              </div>

              {!riskSubmitted && riskVisible && (
                <>
                  <div className="w-[340.166px]">
                    <button type="button" onClick={addRisk} className="mt-1 flex items-center gap-3" style={{ background: "transparent", padding: 0, border: "none" }}>
                      <span className="text-[18px] font-[400] font-[Gotham] text-[#B8B8B8]">+ Add more</span>
                    </button>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      onClick={handleRiskReveal}
                      className="flex items-center justify-between w-[255px] h-[57px] rounded-[20px] bg-[#0D1111] text-white text-[20px] font-[350] font-[Gotham] px-[20px] py-[22px]"
                    >
                      <span className="font-gotham font-medium">Reveal the Future</span>
                      <span className="ml-3 flex items-center justify-center w-[18px] h-[18px] rounded-full bg-white text-black">
                        <svg width={10} height={10} viewBox="0 0 20 20" fill="none">
                          <path d="M8 5l4 5-4 5" stroke="#151A1F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhoYouBecameStep;